import { GetterTypesFromCars } from '@/app/data-flow/cars';

// eslint-disable-next-line import/prefer-default-export
export const GetterTypes = {
  GET_PATH: 'GET_PATH',
  ...GetterTypesFromCars,
};
